import { dataRedoSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconRedoSolid = /*#__PURE__*/createIcon(dataRedoSolid)
export default IconRedoSolid
